function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { Popover } from '@headlessui/react';
import { InputField } from "./";
import { usePopper } from 'react-popper';










const defaultColors = [
'#C03B22',
'#D9534F',
'#E91E63',
'#A03AB1',
'#6F46B8',
'#3F51B5',
'#2196F3',
'#37BDCF',
'#359990',
'#5CB85C',
'#8BC34A',
'#CDDC39',
'#CCBC2F',
'#F0AD4E',
'#EC9920',
'#E46841',
'#795548',
'#9E9E9E',
'#607D8B'];


const ColorPicker = ({
  name,
  className,
  onChange,
  hasErrors,
  value = defaultColors[0],
  options = defaultColors
}) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const changeColor = (color) => {
    setLocalValue(color);
    if (onChange && color.match(/^#([0-9a-fA-F]{6})$/)) {
      onChange(color);
    }
  };

  // Popper integration
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom-start',
    strategy: 'absolute',
    modifiers: [
    {
      name: 'offset',
      options: { offset: [0, 8] }
    }]

  });

  return (/*#__PURE__*/
    _jsx("div", { className: `${className}` }, void 0, /*#__PURE__*/
    _jsx(Popover, { className: "relative" }, void 0,
    ({ close }) => /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement(Popover.Button, {
      ref: setReferenceElement,
      className: "w-[42px] h-[42px] border border-gray-300 cursor-pointer rounded-lg flex items-center justify-center shadow-sm transition hover:border-gray-300 bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500" }, /*#__PURE__*/

    _jsx("div", {
      "data-testid": "colorpicker-button",
      className: "rounded-md w-6 h-6",
      style: { backgroundColor: localValue } }
    )
    ), /*#__PURE__*/
    React.createElement(Popover.Panel, _extends({
      ref: setPopperElement,
      style: styles.popper },
    attributes.popper, {
      className: "flex flex-col gap-2 p-2 bg-white rounded-xl shadow-lg w-56 z-20 border border-gray-100" }), /*#__PURE__*/

    _jsx("ul", {
      className: "grid grid-cols-5 grid-rows-2 gap-2 mb-2 p-2",
      "data-testid": "colorpicker-popover" }, void 0,

    options.map((color) => /*#__PURE__*/
    _jsx("li", {}, color, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "w-8 h-8 rounded-md flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-primary-500",
      onClick: () => {
        changeColor(color);
        close();
      } }, void 0, /*#__PURE__*/

    _jsx("span", { className: "sr-only" }, void 0, color), /*#__PURE__*/
    _jsx("div", {
      "data-testid": "colorpicker-button",
      className: "rounded-md w-8 h-8",
      style: { backgroundColor: color } }
    )
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(InputField, {
      id: name,
      type: "text",
      name: name,
      value: localValue.slice(1),
      preText: "#",
      onChange: (e) => {
        changeColor(`#${e.target.value}`);
      },
      className: "w-full text-center border border-gray-200 rounded-md focus:border-primary-400 focus:ring-1 focus:ring-primary-200",
      hasErrors: hasErrors }
    )
    )
    )

    )
    ));

};

export { ColorPicker };